/**
 *
 * @param commit
 * @param notification_profiles
 */
export function setNotificationProfiles({commit}, notification_profiles) {
    commit('SET_NOTIFICATION_PROFILES', notification_profiles);
}